module.exports = __webpack_public_path__ + "9788f41e/img/rename-icon.de4e673d.svg";